import React, {useState} from 'react'
import {Box, Typography} from '@mui/material'
import {GridRowModel} from '@mui/x-data-grid'
import {RecurrenceCard} from './RecurrenceCard'
import {RecurrenceEditSheet} from './RecurrenceEditSheet'

type RecurrenceCardListProps = {
  rows: GridRowModel[],
  onProcessRowUpdate: (row: GridRowModel) => GridRowModel,
  onDeleteRecurrence: (id: string) => void,
}

export const RecurrenceCardList: React.FC<RecurrenceCardListProps> = ({rows, onProcessRowUpdate, onDeleteRecurrence}) => {
  const [editingId, setEditingId] = useState<string | null>(null)
  const editing = rows.find(r => r.id === editingId) ?? null

  if (rows.length === 0) {
    return <Box sx={{p: 2, textAlign: 'center'}}><Typography color="text.secondary">Pas de récurrence</Typography></Box>
  }

  return (
    <Box>
      {rows.map(row => (
        <RecurrenceCard key={row.id} row={row} onEdit={() => setEditingId(row.id)}/>
      ))}

      {editing && (
        <RecurrenceEditSheet
          open={editingId !== null}
          row={editing}
          onClose={() => setEditingId(null)}
          onSave={(updated) => {onProcessRowUpdate(updated); setEditingId(null)}}
          onDelete={(id) => {onDeleteRecurrence(id); setEditingId(null)}}
        />
      )}
    </Box>
  )
}
